const categories = [
            'sanatoria', 'SPA', 'wellness', 'SPA & Wellness', 'rehabilitacja', 'fizjoterapia', 'fizykoterapia', 'fitness', 'inne'
]
export default categories;